import axios from "../helpers/axios";
import { IBlog, PageableData } from "../helpers/types";

class BlogService {
  public getBlogs = ({ offset, limit }: { offset?: number, limit?: number }) => {
    const url = `/blog/search`;
    return new Promise<PageableData<IBlog[]>>((resolve, reject) => {
      axios
        .get(url, { params: { offset, limit } })
        .then((response) => {
          if (response?.data?.data) resolve(response.data.data);
          else reject("Something went wrong");
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong");
        });
    });
  };


  public getBlogDetails = ({ id }: { id: string }) => {
    const url = `/blog/search/${id}`;
    return new Promise<IBlog>((resolve, reject) => {
      axios
        .get(url)
        .then((response) => {
          if (response?.data?.data?.data) resolve(response.data.data.data);
          else reject("Something went wrong");
        })
        .catch((error) => {
          if (error?.response?.data?.message) reject(error.response.data.message);
          else reject("Something went wrong");
        });
    });
  }
}

export const blogService = new BlogService();
